import { useState, useRef } from "react";
import { useGetConfig } from "@onefront/forrestjs-react-root";
import useQueryString from "use-query-string";

const navigate = (path) => window.history.pushState(null, document.title, path);

const getIsEmbed = (query, urlKey) => {
  // Use existing session setting
  if (query[urlKey] === undefined || query[urlKey] === "") {
    return false;
  }

  // Set the info to session storage for the lifetime of the setting.
  if (["false", "no", "0", "-1"].includes(query[urlKey])) {
    return false;
  } else {
    return true;
  }
};

export const useLayoutEmbed = () => {
  const urlKey = useGetConfig("one.layout.embed.param.key", "embed");
  const tokenParam = useGetConfig("one.auth.token.param", "token");
  const KNOWN_PARAMS = [urlKey, `${urlKey}ID`, `${urlKey}Scope`, tokenParam];

  const [queryString, setQueryString] = useQueryString(
    window.location,
    navigate
  );

  // DEPRECATED:
  // this should be turned into a useRef and the "setIsEmbed" api should be removed
  const [isEmbed, setIsEmbed] = useState(getIsEmbed(queryString, urlKey));

  const embedID = useRef(queryString[`${urlKey}ID`]);
  const embedScope = useRef(queryString[`${urlKey}Scope`]);

  const embedParams = useRef({});
  Object.keys(queryString).forEach((key) => {
    const value = queryString[key];
    if (!KNOWN_PARAMS.includes(key) && Boolean(value)) {
      embedParams.current[key] = value;
    }
  });

  return {
    isEmbed,
    embedID: embedID.current,
    embedScope: embedScope.current,
    embedParams: embedParams.current,
    setIsEmbed: (val) => {
      console.warn(
        "Deprecated: changing embed state from within the app is no longer supported and will be removed in next version"
      );

      setQueryString({ [urlKey]: !!val ? "yes" : "no" });
      setIsEmbed(!!val ? "yes" : "no");
    }
  };
};
